import React from "react";
import styles from "./Blank.module.scss";
import nodeTypeStyles from "../components/nodeTypeComponents.module.css";
export function Blank(props) {
  var _props$content;
  return /*#__PURE__*/React.createElement("div", {
    className: nodeTypeStyles.nodeCovering
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.blank
  }, ((_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.title) || "Blank node"));
}